


































import ModalCreateTag from "./componentTagList/ModalCreateTag.vue";
import { LoadingStatusType } from "@/enums/enums";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreTransaction = namespace("Transaction");

@Component({ components: { ModalCreateTag } })
export default class SectionTagList extends Vue {
  @Prop({}) transactionCreate!: any;

  private selectedTag: any = [];
  private isShowModalCreateTag = false;

  get isTagListLoadingStatus() {
    return this.getTagListLoadingStatus === LoadingStatusType.Loading;
  }

  @StoreTransaction.Getter
  private getTagListLoadingStatus!: LoadingStatusType;

  @StoreTransaction.Getter
  private getTagList!: any;

  @StoreTransaction.Getter
  private getCreateNewTagLoadingStatus!: LoadingStatusType;

  @StoreTransaction.Getter
  private getCreateNewTagRes!: any;

  @StoreTransaction.Action
  private DoGetTagList!: () => void;

  @Watch("getTagListLoadingStatus", { immediate: true, deep: true })
  getTagListLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.None) {
      this.DoGetTagList();
    }
  }
  @Watch("selectedTag", { deep: true })
  selectedTagChanged() {
    this.SetSelectTagTransaction();
  }
  @Watch("getCreateNewTagLoadingStatus", { immediate: true })
  getCreateNewTagLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.DoGetTagList();
      (this.$refs.dropdownComponent as Vue & { SetColorOfNewItem: (id: number) => void }).SetColorOfNewItem(
        this.getCreateNewTagRes.tagId
      );
    }
  }
  public SetSelectTagTransaction() {
    const seletectTagTransaction = [];
    if (this.selectedTag && this.selectedTag.length > 0) {
      for (const selected of this.selectedTag) {
        seletectTagTransaction.push({
          tagName: selected.tagName,
          tagId: selected.tagId,
        });
      }
    }
    this.transactionCreate.tagList = seletectTagTransaction;
  }
}
